import { PublishableCourselike } from '@versita/shared/models';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getCurrentAcademicYear } from '@versita/shared/timetable-utils';

export type FilterName = 'unpublished' | 'published' | 'willNotPublish';

interface TimeTableManagerState {
  selectedIds: string[];
  textFilter: string;
  filteredItems: PublishableCourselike[];
  filters: FilterName[];
  academicYear: string;
}
const initialState: TimeTableManagerState = {
  selectedIds: [],
  textFilter: '',
  filteredItems: [],
  filters: [],
  academicYear: getCurrentAcademicYear(),
};

const timetableManagerSlice = createSlice({
  name: 'timetableManager',
  initialState,
  reducers: {
    setSelectedIds: (state, action: PayloadAction<string[]>) => {
      state.selectedIds = action.payload;
    },
    setTextFilter: (state, action: PayloadAction<string>) => {
      state.textFilter = action.payload;
    },
    setFilteredItems: (
      state,
      action: PayloadAction<PublishableCourselike[]>,
    ) => {
      state.filteredItems = action.payload;
    },
    setStatusFilters: (state, action: PayloadAction<FilterName[]>) => {
      state.filters = action.payload;
    },
    setAcademicYear: (state, action: PayloadAction<string>) => {
      state.academicYear = action.payload;
    },
    resetState: (state) => {
      state.selectedIds = [];
      state.textFilter = '';
      state.filteredItems = [];
      state.filters = [];
      state.academicYear = getCurrentAcademicYear();
    },
  },
});

export const {
  setSelectedIds,
  setTextFilter,
  setFilteredItems,
  setStatusFilters,
  setAcademicYear,
  resetState,
} = timetableManagerSlice.actions;

export default timetableManagerSlice.reducer;
